// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__rh-rN","loaderp":"Loading_loaderp__iwT9V","load":"Loading_load__WD7P4"};